import { render } from "./CardsFrame.vue?vue&type=template&id=df4b28fa&ts=true"
import script from "./CardsFrame.vue?vue&type=script&lang=ts"
export * from "./CardsFrame.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__